<template lang="pug">
  div.inner
    h2 お申込みフォーム確認
    form#post(v-if="sets.length > 0",onsubmit="return false;")
      h3 お申込み者情報入力
      table
        tr
          th お名前
          td
            <!--span.require 必須-->
          td {{ form.user_name1 }}{{ form.user_name2 }}
        tr
          th お名前（フリガナ）
          td
            <!--span.require 必須-->
          td {{ form.user_kana1 }}{{ form.user_kana2 }}
        tr
          th 電話番号
          td
            <!--span.require 必須-->
          td {{ form.user_tel1 }} - {{ form.user_tel2 }} - {{ form.user_tel3 }}
        tr
          th 得意先コード・会社名
          td
            <!--span.require 必須-->
          td
            ul
              li {{ form.user_code }}
              li {{ form.user_company }}
        tr
          th メールアドレス
          td
            <!--span.require 必須-->
          td {{ form.user_email }}
        tr
          th 発注番号
          td
            <!--span.require 必須-->
          td  {{ form.user_number }}
        tr
          th 物件名
          td
            <!--span.require 必須-->
          td {{ form.user_property }}
        <!--tr-->
          <!--th お支払い方法-->
          <!--td-->
            <!--span.require 必須-->
          <!--td {{ form.user_payment }}-->
        tr
          th 納品希望日
          td
            <!--span.require 必須-->
          td {{ form.user_year }} 年 {{ form.user_month }} 月 {{ form.user_day }} 日
      h3 お届け先情報入力
      table
        tr
          th お名前
          td
            <!--span.require 必須-->
          td {{ form.send_name1 }} {{ form.send_name2 }}
        tr
          th お名前（フリガナ）
          td
            <!--span.require 必須-->
          td {{ form.send_kana1 }} {{ form.send_kana2 }}
        tr
          th 電話番号
          td
            <!--span.require 必須-->
          td {{ form.send_tel1 }} - {{ form.send_tel2 }} - {{ form.send_tel3 }}
        tr
          th 会社名
          td
          td {{ form.send_corp }}
        tr
          th メールアドレス
          td
          td {{ form.send_email }}
        tr
          th 郵便番号
          td
            <!--span.require 必須-->
          td {{ form.send_zip1 }} - {{ form.send_zip2 }}
        tr
          th 都道府県
          td
          td {{ form.send_pref }}
        tr
          th 住所
          td
            <!--span.require 必須-->
          td {{ form.send_address1 }}
        tr
          th ビル・マンション名等
          td
            <!--span.require 必須-->
          td {{ form.send_address2 }}
        tr
          th 備考欄
          td
          td {{ form.user_comment }}

      div.submit-area
        button(@click="submitCheck")
          | 申込む
          img(src="@/assets/ico_arrow_right.svg")
        div.back(href="#",@click="backPage") 戻る
</template>

<script>
// import store from '../../stores';
import axios from 'axios';
// import { Core as YubinBangoCore } from 'yubinbango-core2';
export default {
  name: 'Form',
  data () {
    return {
      flow: 'input'
    };
  },
  props: {
    form: Object
  },
  computed: {
    forms () {
      return this.$store.getters.forms;
    },
    year () {
      let d = new Date();
      return d.getFullYear();
    }
  },
  watch: {
  },
  methods: {
    submitCheck () {
      let me = this;
      // let axiosConfig = {
      //   headers: {
      //     'Content-Type': 'application/json;charset=UTF-8',
      //     'Access-Control-Allow-Origin': '*'
      //   }
      // };
      // if (!this.dev) {
      //   axios.post('./static/api/form.json', me.forms, axiosConfig).then(function (response) {
      //     me.afterSubmit(response.data);
      //   });
      // } else {
      //   axios.get('./static/api/form.json', me.forms, axiosConfig).then(function (response) {
      //     me.afterSubmit(response.data);
      //   });
      // }
      // 送信
      let url;
      url = '/api/forms';
      me.loading = true;
      this.axiosConfig.headers.Authorization = 'Bearer ' + localStorage.token;
      axios.post(this.config.baseURL + url, me.forms, this.axiosConfig).then(function (response) {
        me.afterSubmit(response.data);
        me.loading = false;
      }).catch(function (error) {
        me.msg = error.response.data.message || error.message.message;
        document.querySelector('#main').scrollTo({
          top: 0
        });
        me.loading = false;
      });
      return false;
    },
    afterSubmit (dat) {
      if (dat.code === 'success') {
        this.$emit('complete');
      }
    },
    backPage () {
      this.$emit('back');
    }
  },
  created () {
    let d = new Date();
    this.selected_month = d.getMonth() + 1;
    this.selected_day = d.getDate();
  }
};
</script>

<style lang="stylus" scoped>
.form
  background-color #ffffff
  position fixed
  z-index 10000
  left 0
  top 0
  width 100%
  height 100%
#header
  height 77px
  border-bottom 1px solid #DDDDDD
  .inner
    max-width 1040px
    padding 0 20px
    margin 0 auto
    .logo
      padding-top 27px
#main
  position absolute
  left 0
  right 0
  top 78px
  bottom 0
  overflow auto
  .inner
    max-width 1040px
    padding 50px 20px
    margin 0 auto
  h2
    text-align center
    font-size 22px
    margin-bottom 65px
  h3
    padding 5px 0 5px 17px
    border-left 5px solid #2E7C80
    margin-bottom 25px
  table
    margin-bottom 60px
    th
      padding 8px 0
      text-align left
      font-weight normal
      vertical-align top
      &:first-child
        padding-right 20px
    td
      padding 8px 0
      vertical-align top
      span.require
        display inline-block
        color #CC0000
        padding 2px 5px
        border 1px solid #cc0000
        margin-right 20px
        font-size 12px
    ul
      display flex
      align-items center
      li
        margin-right 10px
    select
      width 90px
      background url("../../assets/ico_arrow_down.svg") no-repeat right 5px center
    label
      display inline-block
      overflow hidden
      position relative
    input[type="radio"]
      position absolute
      left -100px
    input[type="radio"] + span
      display inline-block
      width 16px
      height 16px
      border 1px solid #aaaaaa
      border-radius 50%
      vertical-align middle
      margin-top -2px
      margin-right 5px
      position relative
    input[type="radio"]:checked + span:after
      content ""
      display inline-block
      width 8px
      height 8px
      background-color #2E7C80
      border-radius 50%
      position absolute
      left 50%
      top 50%
      transform translate(-50%,-50%)
    textarea
      width 100%
      height 120px
  .submit-area
    text-align center
    /*display  flex*/
    /*justify-content center*/
    margin 0 auto 50px auto
  button,.back
    background-color #2E7C80
    font-size 20px
    font-weight bold
    color #ffffff
    border-radius 8px
    width 324px
    height 64px
    margin 0 auto 25px auto
    display flex
    justify-content center
    align-items center
    text-decoration none
    cursor pointer
    &.back
      background-color #999999
      width 120px
    img
      vertical-align middle
      margin-left 10px
      display inline-block

</style>



// WEBPACK FOOTER //
// src/components/form/ConfirmB.vue